export default __webpack_public_path__ + "static/chrome-1a99bcc993cbec42774ab328559ea001.svg";